import React from 'react';
import { wrapFunctionalComponent } from 'utils/framework';
import languageLocale from 'utils/LanguageLocale';
import { Box, Grid, Icon } from 'components/ui';
import RwdProductPageEN from 'components/ProductPage/locales/RwdProductPage_en_US.js';
import RwdProductPageFR from 'components/ProductPage/locales/RwdProductPage_fr_CA.js';

const getText = text => languageLocale.getLocalisedDataFromResource(RwdProductPageEN, RwdProductPageFR)(text);

function OnlineOnly() {
    return (
        <Box
            lineHeight='tight'
            backgroundColor='nearWhite'
            borderRadius={2}
            padding={[3, 4]}
        >
            <Grid
                lineHeight='tight'
                columns='1fr auto'
                alignItems='center'
            >
                <div data-at={Sephora.debug.dataAt('pdp_marketing_flag')}>{getText('availableOnlineOnly')}</div>
                <Icon
                    css={{ alignSelf: 'flex-start' }}
                    color='gray'
                    name='online'
                />
            </Grid>
        </Box>
    );
}

export default wrapFunctionalComponent(OnlineOnly, 'OnlineOnly');
